"use client"

import type React from "react"
import { BlogListItem } from "./list-item/BlogListItem"
import { CourseListItem } from "./list-item/CourseListItem"
import type { BaseListItemProps } from "./list-item/types"
import { isBlog, isCourse } from "./list-item/types"

const ListItem: React.FC<BaseListItemProps> = ({
	data,
	type = "course",
	refetch,
	cartData,
	showPercentLearned = false,
	showWhiteList = true,
}) => {
	if (!data) return null

	if (type === "blog" && isBlog(data)) {
		return <BlogListItem data={data} type={type} refetch={refetch} />
	}
	// console.log(isCourse(data),'data')

	if (isCourse(data)) {
		return (
			<CourseListItem
				data={data}
				type={type}
				refetch={refetch}
				cartData={cartData}
				showPercentLearned={showPercentLearned}
				showWhiteList={showWhiteList}
			/>
		)
	}

	return null
}

export default ListItem
